export const iconFontAwesomeChartsDiagramsDiagramPredecessor = (
	<i className="fa-solid fa-diagram-predecessor"></i>
);
